import React, { Fragment } from 'react';
import T from 'prop-types';
import { map } from 'lodash-es';

import SmartChart from '../../../../components/Chart/SmartChart';
import defaultLineChartConfig from '../../../../components/Chart/LineChart';
import { numberToHumanChart } from '../../../../utils/formatter';


const chartConfig = defaultLineChartConfig({
  chartOptions: {
    height: 370,
    spacingTop: 10,
    spacingBottom: 10,
  },
  xAxisLabels: {
    enabled: false,
  },
  xAxisOptions: {
    tickWidth: 0,
    tickLength: 0,
    gridLineWidth: 0,
    lineWidth: 0,
    crosshair: false,
    type: 'category',
  },
  yAxisLabels: {
    style: {
      color: '#596985',
      fontSize: 14,
    },
  },
  yAxis: [
    {
      visible: false,
    },
    {
      tickAmount: 6,
      gridLineWidth: 1,
      gridLineColor: '#2B3559',
      visible: true,
      lineWidth: 0,
      offset: 0,
      title: { text: null },
      startOnTick: true,
      endOnTick: true,
      labels: {
        style: {
          color: '#596985',
          fontSize: 14,
        },
        formatter() {
          let value;
          if (this.value < 1) {
            value = this.value;
          } else {
            value = numberToHumanChart(this.value);
          }
          return `${value}`;
        },
      },
    },
  ],
  tooltipOptions: {
    enabled: false,
  },
  responsiveOptions: {
    rules: [{
      condition: {
        maxWidth: 600,
      },
      chartOptions: {
        chart: {
          height: 150,
          marginLeft: 0,
        },
        yAxis: {
          enabled: false,
        },
      },
    }],
  },
  showNoDataMessage: false,
});

const metaSeriesData = {
  kpi_time_series: {
    checked: true,
    color: '#596985',
    name: 'Company-reported KPIs',
    visible: true,
    type: 'spline',
    yAxis: 0,
  },
  metric_time_series: {
    name: 'Apptopia App-Store Intelligence',
    checked: true,
    color: '#00BFFF',
    visible: true,
    type: 'spline',
    yAxis: 1,
  },
};

const Chart = ({ metric_time_series, kpi_time_series }) => {
  const series = {
    metric_time_series, kpi_time_series,
  };

  return (
    <Fragment>
      <SmartChart
        chartId="model-chart"
        series={series}
        metaSeriesData={metaSeriesData}
        config={chartConfig}
        style={{ width: '100%' }}
      />
      <div className="model-chart__legend">
        {map(metaSeriesData, ({ color, name }, seriesKey) => (
          <div key={seriesKey} className="model-chart__legend-item">
            <span
              className="model-chart__legend-item-marker"
              style={{ backgroundColor: color }}
            />
            <p className="model-chart__legend-item-text">{name}</p>
          </div>
          ))}
      </div>
    </Fragment>
  );
};
Chart.propTypes = {
  metric_time_series: T.array,
  kpi_time_series: T.array,
};
export default Chart;
